const parsley = () => {
  const elems = document.querySelectorAll('.js-parsley-form');

  elems.forEach((elem) => {
    $(elem).parsley(
      {
        noFocus: false,
      }
    );
  });
};

const wow = () => {
    const wowInit = new WOW(
    {
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 80,
      mobile: false,
      live: true,
    }
  );

  wowInit.init();
};

const masks = () => {
	document.querySelectorAll('.js-phone-mask').forEach((phone) => {
		const mask = IMask(phone, {
			mask: '{+7} (000) 000-00-00',
		});

		phone.addEventListener('paste', function (evt) {
			let paste = (evt.clipboardData || window.clipboardData).getData(
				'text'
			);

			if (paste.startsWith('+7')) {
				mask.updateOptions({
					mask: '{+7} (#00) 000-00-00',
					definitions: {
						'#': /[012345689]/,
					},
				});
			}

			if (paste.startsWith('8')) {
				mask.updateOptions({
					mask: '{+7} (#00) 000-00-00',
					definitions: {
						'#': /[012345679]/,
					},
				});
			}
		});

		phone.addEventListener(
			'focus',
			() => {
				mask.updateOptions({ lazy: false });
			},
			true
		);
		phone.addEventListener(
			'blur',
			() => {
				mask.updateOptions({ lazy: true });
			},
			true
		);
	});

	document
		.querySelectorAll('.js-number-mask')
		.forEach((number) => IMask(number, { mask: '000000' }));

	document
		.querySelectorAll('.js-card-mask')
		.forEach((card) => IMask(card, { mask: '0000-0000-0000-0000' }));

	document
		.querySelectorAll('.js-price-mask')
		.forEach((price) => IMask(price, { mask: '0 000 000 000' }));
};

const orderForm = () => {
  const elems = document.querySelectorAll('.js-order-form');

  elems.forEach((elem) => {
    const btn = elem.querySelector('.js-btn');

    btn.addEventListener('click', () => {
      const isActive = elem.classList.contains('active');
      const mobile = window.matchMedia('(max-width: 980px)').matches;

      if(isActive){
        elem.classList.remove('active');
        if(mobile){
          OD.body.classList.remove('overflow');
        }
      }else{
        elem.classList.add('active');
        if(mobile){
          OD.body.classList.add('overflow');
        }
      }
    });

    document.documentElement.addEventListener('click', function (event) {
      var isClickWithinOpenedDiv = top_walker(event.target, function (node) {
        return node === elem
      });
      if (isClickWithinOpenedDiv) {

      }else{
        elem.classList.remove('active');
      }
    }, true);
  });
};

const tabs = () => {
	const btns = document.querySelectorAll('[data-tabclass]');

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const contentData = btn.getAttribute('data-tabclass');
      const btnNumberData = btn.getAttribute('data-tabnumber');
      const contentNodes = document.querySelectorAll(`.${contentData}`);
      const btnSiblings = getSiblings(btn);

      // toggle btn class
      btnSiblings.forEach((btnSibling) => {
        btnSibling.classList.remove('active');
      });

      btn.classList.add('active');

      // toggle contentNodes
      contentNodes.forEach((contentNode) => {
        const items = Array.from(contentNode.children);

        items.forEach((item) => {
          const itemNumberData = item.getAttribute('data-tabnumber');
          const isNumberEqual = itemNumberData == btnNumberData;

          if(isNumberEqual) {
            const siblings = getSiblings(item);

            siblings.forEach((sibling) => {
              sibling.classList.remove('active');
            });

            item.classList.add('active');
          }
        });
      });
    });
  });
};

const mobileMenu = () => {
  const btnsOpen = document.querySelectorAll('.js-burger');
  const menus = document.querySelectorAll('.js-mobile-menu');

  btnsOpen.forEach((btnOpen) => {
    btnOpen.addEventListener('click', () => {
      const menu = document.querySelector('.js-mobile-menu');
      const isActive = menu.classList.contains('active');

      if(isActive){
        menu.classList.remove('active');
        OD.body.classList.remove('overflow');
        OD.warningNode.classList.remove('hide');
      }else{
        menu.classList.add('active');
        OD.body.classList.add('overflow');
        OD.warningNode.classList.add('hide');
      }
    });
  });

  menus.forEach((menu) => {
    const btnsClose = menu.querySelectorAll('.js-close');

    btnsClose.forEach((btnClose) => {
      btnClose.addEventListener('click', () => {
        const isActive = menu.classList.contains('active');

        if(isActive){
          menu.classList.remove('active');
          OD.body.classList.remove('overflow');
          OD.warningNode.classList.remove('hide');
        }else{
          menu.classList.add('active');
          OD.body.classList.add('overflow');
          OD.warningNode.classList.add('hide');
        }
      });
    });
  });
};

const select = () => {
  const selects = document.querySelectorAll('.js-select');

  selects.forEach((select) => {
    const btn = select.querySelector('.js-select-btn');

    const close = (select) => {
      select.classList.remove('active');
      OD.globalDropdown.remove();
    };

    const open = () => {
      select.classList.add('active');
    };

    btn.addEventListener('click', (e) => {
      const coords = getCoords(btn);
      OD.isSelectActive = select.classList.contains('active');

      if(OD.isSelectActive){
        close(select);
      }else {
        selects.forEach((select) => {
          select.classList.remove('active');
        });

        select.classList.add('active');
        if(OD.globalDropdown){
          OD.globalDropdown.remove();
        }


        // clone list node & append it
        const cloneList = select.querySelector('.js-list').cloneNode(true);
        OD.dropdown.appendChild(cloneList);

        // set list position + make it visible
        const selectParams = select.getBoundingClientRect();
        const coordsY = coords.top + selectParams.height;
        OD.globalDropdown = OD.dropdown.querySelector('.js-list');
        OD.globalDropdown.setAttribute('style', `left: ${coords.left}px; top: ${coordsY}px; width:${selectParams.width}px;`);
        OD.globalDropdown.classList.add('active');

        // options listener
        const options = OD.dropdown.querySelectorAll('.js-select-option');

        options.forEach((option) => {
          option.addEventListener('click', () => {
            const activeSelects = document.querySelectorAll('.js-select.active');
            activeSelects.forEach((activeSelect) => {
              const text = activeSelect.querySelector('.js-select-text');

              const value = option.innerText;
              text.innerText = value;

              close(select);
            });

          });
        });
      }
    });

    document.documentElement.addEventListener('click', function (event) {
    	var isClickWithinOpenedDiv = top_walker(event.target, function (node) {
    		return node === OD.globalDropdown
    	});
    	if (isClickWithinOpenedDiv) {

    	}else{
        const isActive = select.classList.contains('active');
        const isBtn = event.target.classList.contains('js-select-btn');

        if(isActive){
          if(isBtn){

          }else{
            close(select);
          }
        }else{

        }
      }
    }, true);
  });
};

const historySlider = () => {
  const sliders = document.querySelectorAll('.js-slider-history');

  sliders.forEach((slider) => {
    const options = {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 400,
      variableWidth: true,
      centerMode: true,
      focusOnSelect: true
    };
    const section = slider.closest('.js-history');
    const msg = section.querySelector('.js-msg');

    $(slider).slick(options);

    $(slider).slick('slickGoTo', 4);

    $(slider).on('afterChange', function(event, slick, currentSlide, nextSlide){
      const currentSlideNode = slick.$slides[currentSlide];
      const dataDesc = currentSlideNode.getAttribute('data-desc');
      msg.innerText = dataDesc;
    });

    setTimeout(() => {
      section.classList.add('init');
    }, 400);
  });
};

const accordion = () => {
  const btns = document.querySelectorAll('.js-accordion-btn');

  btns.forEach((btn) => {
    btn.addEventListener('click', (evt) => {
      evt.preventDefault();
      const parentItem = btn.closest('.js-accordion-item');
      const itemSiblings = getSiblings(parentItem);
      const isActive = parentItem.classList.contains('active');

      // show/hide accordion-content
      itemSiblings.forEach((itemSibling) => {
        itemSibling.classList.remove('active');
      });

      if (isActive) {
        parentItem.classList.remove('active');
      } else {
        parentItem.classList.add('active');
      }

      // scroll to accordion-content
      const btnCoords = getCoords(btn);
      const scrollTop = btnCoords.top - 400;

      window.scroll({
        top: scrollTop,
        behavior: 'smooth'
      });
    });
  });
};

const map = () => {
	const mapBlocks = document.querySelectorAll('#map');

	//internet__map

	mapBlocks.forEach((mapBlock) => {
		let myPlacemark;
		const dataCoords = mapBlock.getAttribute('data-coords');
		const latitude = dataCoords.split(',')[0];
		const longitude = dataCoords.split(',')[1];
		const coords = [];
		coords.push(latitude);
		coords.push(longitude);

		ymaps.ready(() => {
			const myMap = new ymaps.Map(
				'map',
				{
					center: coords,
					zoom: 14,
				},
				{
					searchControlProvider: 'yandex#search',
				}
			);

			if (mapBlock.classList.contains('internet__map')) {
				myPlacemark = new ymaps.Placemark(
					myMap.getCenter(),
					{
						balloonContentBody:
							'<div class="balloon">' +
							'<div class="balloon__address">Московская область, г. Одинцово, ул. Липовая, д. 26</div>' +
							'<div class="balloon__status">Ваш дом подключен</div>' +
							'<ul class="balloon__list">' +
							'<li class="balloon__item">' +
							'<span>Цифровое ТВ</span>' +
							'<img src="/assets/img/css/done.png" width="15" height="15">' +
							'<li class="balloon__item">' +
							'<span>Кабельное ТВ</span>' +
							'<img src="/assets/img/css/done.png" width="15" height="15">' +
							'</li>' +
							'<li class="balloon__item">' +
							'<span>Интернет</span>' +
							'<img src="/assets/img/css/none.png" width="15" height="15">' +
							'</li>' +
							'</ul>' +
							'</div>',
					},
					{
						iconLayout: 'default#image',
						iconImageHref: '/assets/img/css/pin.svg',
						iconImageSize: [71, 95],
						iconImageOffset: [-35.5, -47.5],
						hideIconOnBalloonOpen: false,
						balloonOffset: [-150, -15],
					}
				);

				myMap.options.set('scrollZoomSpeed', 0);
				myMap.behaviors.disable('scrollZoom');
				myMap.geoObjects.add(myPlacemark);
				myPlacemark.balloon.open(coords, '', {
					closeButton: false,
					minWidth: window.innerWidth < 400 ? window.innerWidth : 400,
					maxWidth: 400,
					panelMaxMapArea: window.innerWidth <= 500 ? Infinity : 0,
				});
			} else {
				myPlacemark = new ymaps.Placemark(
					myMap.getCenter(),
					{},
					{
						iconLayout: 'default#image',
						iconImageHref: '/assets/img/css/pin.svg',
						iconImageSize: [71, 95],
						iconImageOffset: [-35.5, -47.5],
					}
				);

				myMap.options.set('scrollZoomSpeed', 0);
				myMap.behaviors.disable('scrollZoom');
				myMap.geoObjects.add(myPlacemark);
			}

			// remove drag for mobile
			if (window.matchMedia('(max-width: 980px)').matches) {
				myMap.behaviors.disable('drag');
			}

			// remove controls
			myMap.controls.remove('geolocationControl');
			myMap.controls.remove('searchControl');
			myMap.controls.remove('trafficControl');
			myMap.controls.remove('typeSelector');
			myMap.controls.remove('fullscreenControl');
			myMap.controls.remove('rulerControl');
			myMap.controls.remove('zoomControl');

			myMap.controls.add('zoomControl', {
				position: {
					top: '20px',
					right: '20px',
				},
			});
		});
	});
};

const tag = () => {
  const tags = document.querySelectorAll('.js-tag');

  tags.forEach((tag) => {
    tag.addEventListener('click', () => {
      const isActive = tag.classList.contains('active');

      if(isActive){
        tag.classList.remove('active');
      }else{
        tag.classList.add('active');
      }
    });
  });
};

const cardChannel = () => {
	const cards = document.querySelectorAll('.js-card-channel');

	cards.forEach((card) => {
		card.addEventListener('click', (evt) => {
			evt.preventDefault();

			const cardObj = {};
			cardObj.imgSrc = card.getAttribute('data-imgSrc');
			cardObj.imgSrcWebp = card.getAttribute('data-imgsrcwebp');
			cardObj.title = card.getAttribute('data-title');
			cardObj.titleDesc = card.getAttribute('data-title-desc');
			cardObj.number = card.getAttribute('data-number');
			cardObj.desc = card.getAttribute('data-desc');

			if (!cardObj.desc) return;

			const isCardPopup =
				document.querySelector('.js-popup-channel') != null;

			if (isCardPopup) {
				const cardPopup = document.querySelector('.js-popup-channel');

				const img = cardPopup.querySelector('.js-img');
				const imgSourceWebp = img.querySelector('.js-source-webp');
				const imgSourcePng = img.querySelector('.js-source-png');
				const imgSourceImg = img.querySelector('.js-source-img');
				const title = cardPopup.querySelector('.js-title');
				const isTitleDesc =
					cardPopup.querySelectorAll('.js-title-desc').length != 0;
				const titleDesc = cardPopup.querySelector('.js-title-desc');
				const numbers = cardPopup.querySelectorAll('.js-number');
				const desc = cardPopup.querySelector('.js-desc');

				if (!cardObj.imgSrc || !cardObj.imgSrcWebp) {
					img.parentElement.style.display = 'none';
				} else {
					const dataImgType = cardObj.imgSrc.split('.')[1];

					imgSourceWebp.setAttribute(
						'srcset',
						`${cardObj.imgSrcWebp}`
					);
					imgSourcePng.setAttribute('srcset', `${cardObj.imgSrc}`);
					imgSourcePng.setAttribute('type', `image/${dataImgType}`);
					imgSourceImg.setAttribute('src', `${cardObj.imgSrc}`);
				}

				title.innerText = cardObj.title;
				if (isTitleDesc) {
					titleDesc.innerText = cardObj.titleDesc;
				}
				numbers.forEach((number) => {
					number.innerText = cardObj.number;
				});
				desc.innerText = cardObj.desc;

				cardPopup.classList.add('active');
				OD.body.classList.add('overflow');
			}
		});
	});
};

const popupChannel = () => {
	const popups = document.querySelectorAll('.js-popup-channel');

	popups.forEach((popup) => {
		const btnClose = popup.querySelector('.js-close');
		const img = popup.querySelector('.js-img');
		const imgSourceWebp = img.querySelector('.js-source-webp');
		const imgSourcePng = img.querySelector('.js-source-png');
		const imgSourceImg = img.querySelector('.js-source-img');
		const title = popup.querySelector('.js-title');
		const desc = popup.querySelector('.js-desc');
		const content = popup.querySelector('.popup-channel__container');
		const isTitleDesc =
			popup.querySelectorAll('.js-title-desc').length != 0;

		const isNumber = popup.querySelectorAll('.js-number').length != 0;

		const close = () => {
			popup.classList.remove('active');
			OD.body.classList.remove('overflow');

			imgSourceWebp.setAttribute('srcset', '');
			imgSourcePng.setAttribute('srcset', '');
			imgSourceImg.setAttribute('src', '');

			title.innerText = '';

			if (isNumber) {
				popup.querySelector('.js-number').innerText = '';
			}

			if (isTitleDesc) {
				popup.querySelector('.js-title-desc').innerText = '';
			}

			desc.innerText = '';
		};

		btnClose.addEventListener('click', close);

		document.addEventListener('keyup', (evt) => {
			if (evt.key === 'Escape' && popup.classList.contains('active')) {
				close();
			}
		});

		document.documentElement.addEventListener(
			'click',
			(evt) => {
				const isActive = popup.classList.contains('active');

				var isClickWithinOpenedDiv = top_walker(
					evt.target,
					(node) => node === content
				);

				if (!isClickWithinOpenedDiv && isActive) {
					close();
				}
			},
			true
		);
	});
};

const swiper = () => {
	var swiper = new Swiper('.swiper-container', {
		parallax: true,
		speed: 700,
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.js-slider-arrow-prev',
			prevEl: '.js-slider-arrow-next',
		},
	});
};

const toggle = () => {
	const toggleBtns = document.querySelectorAll('.js-toggle-btn');
	const toggles = document.querySelectorAll('.js-toggle');

	toggleBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const width = OD.body.clientWidth;
			const toggle = btn.querySelector('.js-toggle');
			toggle.classList.toggle('active');

			width > OD.mobile
				? basket.handleButtonClick()
				: basket.handleButtonClickMobile();

			// if (toggle.classList.contains('active')) {
			// 	width > OD.mobile
			// 		? basket.handleButtonClick()
			// 		: basket.handleButtonClickMobile();
			// } else {
			// 	basket.handleClose();
			// 	toggles.forEach((toggleItem) =>
			// 		toggleItem.classList.remove('active')
			// 	);
			// }
		});
	});

	toggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const width = OD.body.clientWidth;
			toggle.classList.toggle('active');

			width > OD.mobile ? basket.open() : basket.openMobile();
		});
	});
};

const tariffSlider = () => {
  const sliders = document.querySelectorAll(".js-slider-tariff");
  const items = document.querySelectorAll(".js-type-item");

  sliders.forEach((slider) => {
    const options = {
      dots: slider.children.length > 1 ? true : false,
      arrows: true,
      infinite: false,
      speed: 400,
      variableWidth: true,
      prevArrow: `<button type="button" class="arrow arrow--prev news-slider__btn news-slider__btn--prev">
            <svg class="icon icon--circle-arrow-prev">
              <use xlink:href="#circle-arrow-prev"></use>
            </svg>
          </button>`,
      nextArrow: `<button type="button" class="arrow arrow--next news-slider__btn news-slider__btn--next">
        <svg class="icon icon--circle-arrow-next">
          <use xlink:href="#circle-arrow-next"></use>
        </svg>
      </button>`,
      responsive: [
        {
          breakpoint: 980,
          settings: {
            arrows: false,
          },
        },
      ],
    };

    $(slider).slick(options);
  });
};

const popupGallery = () => {
  const popupGalleryObj = {
    slides: [],
    movePrev() {
      this.slides.forEach((slide, index) => {
        const isActive = slide.active == true;
        slide.active = false;

        if(isActive){
          let prevIndex = index - 1;
          if(prevIndex <= 0){
            prevIndex = 0;
          }
          const prevSlide = this.slides[prevIndex];
          prevSlide.active = true;

          this.changePopup(prevSlide);
        }
      });
    },
    moveNext() {
      const lastIndex = this.slides.length - 1;
      let currentItem = popupGalleryObj.slides.map(e => e.active).indexOf(true);
      if(currentItem >= lastIndex){
        currentItem = lastIndex - 1;
      }

      const nextItem = this.slides[currentItem + 1];

      this.slides.forEach((slide) => {
        slide.active = false;
      });
      nextItem.active = true;

      this.changePopup(nextItem);
    },
    changePopup(slide) {
      const popup = document.querySelector('.js-popup-gallery');
      const img = popup.querySelector('.js-img');
      const imgSourceWebp = img.querySelector('.js-source-webp');
      const imgSourcePng = img.querySelector('.js-source-png');
      const imgSourceImg = img.querySelector('.js-source-img');
      const header = popup.querySelector('.js-header');

      imgSourceWebp.setAttribute('srcset', `${slide.img}`);
      imgSourcePng.setAttribute('srcset', `${slide.img}`);
      imgSourceImg.setAttribute('src', `${slide.img}`);
      header.innerText = slide.header;
      
      const dataImgType = imgSourcePng.srcset.split('.')[1];

      imgSourcePng.setAttribute('type', `image/${dataImgType}`);
    }
  };
  const openBtns = document.querySelectorAll('.js-popup-gallery-open');
  const isOpenBtn = document.querySelectorAll('.js-popup-gallery-open').length != 0;

  if(isOpenBtn){
    const btnPrev = document.querySelector('.js-popup-btn--prev');
    const btnNext = document.querySelector('.js-popup-btn--next');
    const isImgFocus = document.querySelector('.js-is-img-focus');

    if(isImgFocus){
      const popup = document.querySelector('.js-popup-gallery');
      popup.classList.add('popup-gallery--img-focus');
    }

    btnPrev.addEventListener('click', () => {
      popupGalleryObj.movePrev();
    });

    btnNext.addEventListener('click', () => {
      popupGalleryObj.moveNext();
    });

    openBtns.forEach((btn) => {
      const popup = document.querySelector('.js-popup-gallery');
      const galleryItems = document.querySelectorAll('.js-gallery-item');
      const closeBtn = popup.querySelector('.js-close');
      const img = popup.querySelector('.js-img');
      const imgSourceWebp = img.querySelector('.js-source-webp');
      const imgSourcePng = img.querySelector('.js-source-png');
      const imgSourceImg = img.querySelector('.js-source-img');
      const header = popup.querySelector('.js-header');
      const content = popup.querySelector('.js-content');

      const open = (dataImg, dataImgWebp, dataHeader) => {
        const itemObj = {};
        const dataImgType = dataImg.split('.')[1];

        OD.body.classList.add('overflow');
        popup.classList.add('active');
        imgSourceWebp.setAttribute('srcset', `${dataImgWebp}`);
        imgSourcePng.setAttribute('srcset', `${dataImg}`);
        imgSourcePng.setAttribute('type', `image/${dataImgType}`);

        imgSourceImg.setAttribute('src', `${dataImgWebp}`);
        header.innerText = dataHeader;

        const currentItem = btn.closest('.js-gallery-item');
        if(currentItem){
          currentItem.classList.add('active');
        }else{
          const firstItem = document.querySelector('.js-gallery-item');
          firstItem.classList.add('active');
        }

        galleryItems.forEach((galleryItem, index) => {
          const isActive = galleryItem.classList.contains('active');
          const itemObj = {};
          const dataImg = galleryItem.getAttribute('data-img');
          const dataHeader = galleryItem.getAttribute('data-header');
          itemObj.id = index;
          itemObj.img = dataImg;
          itemObj.header = dataHeader;
          itemObj.active = false;
          if(isActive){
            itemObj.active = true;
          }
          popupGalleryObj.slides.push(itemObj);
        });
      };

      const close = () => {
        OD.body.classList.remove('overflow');
        popup.classList.remove('active');
        imgSourceWebp.setAttribute('srcset', ``);
        imgSourcePng.setAttribute('srcset', ``);
        imgSourceImg.setAttribute('src', ``);
        header.innerText = '';

        popupGalleryObj.slides = [];
        galleryItems.forEach((galleryItem) => {
          galleryItem.classList.remove('active');
        });
      };

      btn.addEventListener('click', () => {
        const dataImg = btn.getAttribute('data-img');
        const dataImgWebp = btn.getAttribute('data-imgwebp');
        const dataHeader = btn.getAttribute('data-header');
        
        open(dataImg, dataImgWebp, dataHeader);
      });

      closeBtn.addEventListener('click', () => {
        close();
      });

      document.addEventListener('keyup', (e) => {
        const isEsc = e.keyCode == OD.ESC_CODE;
        const isActive = popup.classList.contains('active');

        if(isEsc && isActive){
          close();
        }
      });

      document.documentElement.addEventListener('click', function (event) {
        var isClickWithinOpenedDiv = top_walker(event.target, function (node) {
          return node === content
        });
        if (isClickWithinOpenedDiv) {

        }else{
          close();
        }
      }, true);
    });
  }
};

const mobileForm = () => {
	const openBtns = document.querySelectorAll('.js-open-order-form');
	const orderForm = document.querySelector('.js-order-form');

	openBtns.forEach((openBtn) => {
		const open = () => {
			orderForm.classList.add('active');
			OD.body.classList.add('overflow');
			OD.header.style.zIndex = 1001;
		};

		const close = () => {
			orderForm.classList.remove('active');
			OD.body.classList.remove('overflow');
			OD.header.style.zIndex = 999;
		};

		openBtn.addEventListener('click', () => {
			const isActive = orderForm.classList.contains('active');

			if (isActive) {
				close();
			} else {
				open();
			}
		});
	});
};

const newsSlider = () => {
  const sliders = document.querySelectorAll('.js-news-slider');

  sliders.forEach((slider) => {
    const options = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 400,
      prevArrow: `<button type="button" class="news-slider__btn news-slider__btn--prev">
            <svg class="icon icon--circle-arrow-prev">
              <use xlink:href="#circle-arrow-prev"></use>
            </svg>
          </button>`,
      nextArrow: `<button type="button" class="news-slider__btn news-slider__btn--next">
        <svg class="icon icon--circle-arrow-next">
          <use xlink:href="#circle-arrow-next"></use>
        </svg>
      </button>`,
      dots: true
    };

    $(slider).slick(options);
  });
};

const subTag = () => {
  const btns = document.querySelectorAll('.js-subtag-btn');

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
    });
  });
};

const switcher = () => {
  const elems = document.querySelectorAll('.js-switcher');
  const cardsContainers = document.querySelectorAll('.js-card-channel-col');

  elems.forEach((elem) => {
    const btns = elem.querySelectorAll('.js-switcher-btn');

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const isRow = btn.classList.contains('row');

        if(isRow){
          cardsContainers.forEach((cardsContainer) => {
            cardsContainer.classList.remove('column');
          });
        }else{
          cardsContainers.forEach((cardsContainer) => {
            cardsContainer.classList.add('column');
          });
        }
      });
    });
  });
};

const tariffThemeSwitch = () => {
  const isSection = document.querySelectorAll(".js-tariffs").length != 0;

  if (isSection) {
    const section = document.querySelector(".js-tariffs");
    const elems = section.querySelectorAll(".js-type-li");
    const tabBtns = section.querySelectorAll(".tab-list__li");

    tabBtns.forEach((tabBtn) => {
      tabBtn.addEventListener("click", () => {
        const tabItemActive = tabBtn
          .closest(".js-tariffs")
          .querySelector(".js-tab-item.active");
        const activeThemeColor = tabItemActive
          .querySelector(".js-type-li.active")
          .getAttribute("data-themecolor");

        const imgCol = tabItemActive.querySelector(".js-img-col");
        const typeLi = tabItemActive.querySelectorAll(".js-type-li");

        imgCol.style = `background: ${activeThemeColor}`;
        typeLi.forEach((typeLi) => {
          const typeItem = typeLi.querySelector(".js-type-item");
          typeItem.style = `border-color: ${activeThemeColor}`;
        });
      });
    });

    elems.forEach((elem) => {
      elem.addEventListener("click", () => {
        const dataTheme = elem.getAttribute("data-themecolor");

        const tariffCard = elem.closest(".js-tariff-card");
        const imgCol = tariffCard.querySelector(".js-img-col");
        const typeLi = tariffCard.querySelectorAll(".js-type-li");

        imgCol.style = `background: ${dataTheme}`;
        typeLi.forEach((typeLi) => {
          const typeItem = typeLi.querySelector(".js-type-item");
          typeItem.style = `border-color: ${dataTheme}`;
        });
      });
    });
  }
};

const tariffDetailThemeSwitch = () => {
  const containers = document.querySelectorAll(".tariff-img-js");

  containers.forEach((container) => {
    container.style.backgroundColor = container.dataset.themecolor;
  });
};

const productAnimate = () => {
  const elems = document.querySelectorAll('.js-product-animate');

  elems.forEach((elem) => {
    const icon = document.querySelector('.js-icon-animate');
    const iconMobile = document.querySelector('.js-icon-animate-mobile');

    elem.addEventListener('click', () => {
      const isActive = elem.querySelector('.js-toggle').classList.contains('active');
      const basket = document.querySelector('.js-basket-open');
      const basketMobile = document.querySelector('.js-basket-open-mob');
      const basketCoords = getCoords(basket);
      const basketCoordsMobile = getCoords(basketMobile);
      const btnCoords = getCoords(elem.querySelector('.icon'));

      if(isActive){
        icon.animate([
          {left: `${btnCoords.left}px`, top: `${btnCoords.top}px`, opacity: 1},
          {left: `${basketCoords.left + 37}px`, top: `${basketCoords.top + 10}px`, opacity: 0.5},
          {left: `${basketCoords.left + 37}px`, top: `${basketCoords.top + 10}px`, opacity: 0},
        ], {
          duration: 800,
          easing: 'ease-in'
        });

        iconMobile.animate([
          {left: `${btnCoords.left}px`, top: `${btnCoords.top}px`, opacity: 1},
          {left: `${basketCoordsMobile.left - 2}px`, top: `${basketCoordsMobile.top - 6}px`, opacity: .5},
          {left: `${basketCoordsMobile.left - 2}px`, top: `${basketCoordsMobile.top - 6}px`, opacity: 0},
        ], {
          duration: 800,
          easing: 'ease-in'
        });

      }else{

      }

    });
  });
};

const tariffSwitcher = () => {
	const btns = document.querySelectorAll('.js-make-tariff');

	btns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const isActive = btn
				.querySelector('.js-toggle')
				.classList.contains('active');
			const currentItem = btn.closest('.js-tariff-item');

			if (currentItem) {
				const toggles = currentItem.querySelectorAll(
					'.js-tariff-services .js-toggle'
				);
				const tariffList = currentItem.closest(
					'.js-tariffs-img-content'
				);
				const isItems =
					document.querySelectorAll('.tariffs__img-li').length != 0;

				if (isItems) {
					const items = tariffList.querySelectorAll(
						'.tariffs__img-li'
					);
					items.forEach((item) => {
						const isActive = item.classList.contains('active');

						if (isActive) {
						} else {
							const toggleNode = item.querySelector(
								'.js-make-tariff .js-toggle'
							);
							toggleNode.classList.remove('active');
						}
					});
				}

				const open = () => {
					toggles.forEach((toggle) => {
						toggle.classList.add('disabled');
					});
				};

				const close = () => {
					toggles.forEach((toggle) => {
						toggle.classList.remove('disabled');
					});
				};

				isActive ? close() : open();
			}
		});
	});
};

const warning = () => {
	const isWarning = document.querySelectorAll('.js-warning').length != 0;

	if (isWarning) {
		const warning = document.querySelector('.js-warning');
    const header = document.querySelector('.page-header');

    header.style.top = warning.clientHeight + 'px'
		OD.warningCloseButton.addEventListener('click', () => {
			const isActive = warning.classList.contains('active');
			if (isActive) {
				warning.classList.remove('active');
        header.style.top = warning.clientHeight + 'px'
			} else {
				warning.classList.add('active');
			}
		});
	}
};

const MIN_WIDTH = 280;
const MIN_MARGIN = 25;

const breakpoints = {
	sm: MIN_WIDTH * 2 + MIN_MARGIN * 1,
	md: MIN_WIDTH * 3 + MIN_MARGIN * 2,
	ml: MIN_WIDTH * 4 + MIN_MARGIN * 3,
};

const getCurrSliderWidth = () => {
	return document.querySelector('.tariff-detail').offsetWidth;
};

const getCurrItemSize = () => {
	const currSliderWidth = getCurrSliderWidth();

	switch (true) {
		case currSliderWidth <= breakpoints.sm:
			return {
				width: '280px',
				marginRight: '20px',
			};
		case currSliderWidth <= breakpoints.md:
			return {
				width: currSliderWidth * (MIN_WIDTH / breakpoints.sm) + 'px',
				marginRight:
					currSliderWidth * (MIN_MARGIN / breakpoints.sm) + 'px',
			};
		case currSliderWidth <= breakpoints.ml:
			return {
				width: currSliderWidth * (MIN_WIDTH / breakpoints.md) + 'px',
				marginRight:
					currSliderWidth * (MIN_MARGIN / breakpoints.md) + 'px',
			};
		case currSliderWidth > breakpoints.ml:
			return {
				width: currSliderWidth * (MIN_WIDTH / breakpoints.ml) + 'px',
				marginRight:
					currSliderWidth * (MIN_MARGIN / breakpoints.ml) + 'px',
			};
		default:
			return {
				width: '280px',
				marginRight: '20px',
			};
	}
};

const setCurrItemSize = (slider) => {
	const articles = slider.querySelectorAll('article');

	articles.forEach((item, index, array) => {
		const style = getCurrItemSize();
		item.style.width = style.width;
		item.style.marginRight =
			index < array.length - 1 ? style.marginRight : 0;
	});
};

const changeArrowPosition = (slider) => {
	const fromMobile = window.matchMedia('(min-width: 981px)').matches;

	if (fromMobile) {
		clearInterval(timer);

		const timer = setTimeout(() => {
			const arrowPrev = slider
				.closest('div')
				.querySelector('.arrow--prev');
			const arrowNext = slider
				.closest('div')
				.querySelector('.arrow--next');

			if (arrowPrev && arrowNext) {
				const imgHeight =
					slider.querySelector('.tariff-detail__img-col')
						.offsetHeight / 2;

				arrowPrev.style.top = `${imgHeight}px`;
				arrowNext.style.top = `${imgHeight}px`;
			}
		}, 300);
	}
};

const setMinHeight = (slider) => {
	const items = slider.querySelectorAll('.tariff-detail__item');

	const minHeight = Math.max(...[...items].map((elem) => elem.clientHeight));

	items.forEach((item) => {
		item.style.minHeight = minHeight + 'px';

		const service = item.querySelector('.js-services');
		const btn = item.querySelector('.js-btn');
		const btnClose = item.querySelector('.js-close');

		const handleOpen = () => {
			service.classList.add('active');
			item.style.height =
				minHeight + service.clientHeight - btn.clientHeight + 'px';
		};

		const handleClose = () => {
			service.classList.remove('active');
			item.style.height = 'auto';
		};

		if (btn) {
			btn.addEventListener('click', () => {
				const isActive = service.classList.contains('active');

				isActive ? handleClose() : handleOpen();
			});
		}

		if (btnClose) {
			btnClose.addEventListener('click', handleClose);
		}

	});
};

const tariffDetailSlider = () => {
	const sliders = document.querySelectorAll('.js-tariff-detail-slider');

	sliders.forEach((slider) => {
		const options = {
			arrows: true,
			slidesToShow: 4,
			infinite: false,
			speed: 400,
			variableWidth: true,
			dots: slider.children.length > 4 ? true : false,
			responsive: [
				{
					breakpoint: 1551,
					settings: {
						arrows: true,
						slidesToShow: 3,
						dots: slider.children.length > 3 ? true : false,
					},
				},
				{
					breakpoint: 1057,
					settings: {
						arrows: false,
						slidesToShow: 2,
						dots: slider.children.length > 2 ? true : false,
					},
				},
				{
					breakpoint: 981,
					settings: {
						arrows: true,
						slidesToShow: 3,
						dots: slider.children.length > 3 ? true : false,
					},
				},
				{
					breakpoint: 921,
					settings: {
						arrows: false,
						slidesToShow: 2,
						dots: slider.children.length > 2 ? true : false,
					},
				},
				{
					breakpoint: 616,
					settings: {
						arrows: false,
						slidesToShow: 1,
						dots: slider.children.length > 1 ? true : false,
					},
				},
			],
			prevArrow: `<button type="button" class="arrow arrow--prev news-slider__btn news-slider__btn--prev">
            <svg class="icon icon--circle-arrow-prev">
              <use xlink:href="#circle-arrow-prev"></use>
            </svg>
          </button>`,
			nextArrow: `<button type="button" class="arrow arrow--next news-slider__btn news-slider__btn--next">
        <svg class="icon icon--circle-arrow-next">
          <use xlink:href="#circle-arrow-next"></use>
        </svg>
      </button>`,
		};

    $(slider).slick(options);

    setCurrItemSize(slider);
    changeArrowPosition(slider);
    setMinHeight(slider);

    $(window).on('resize', function() {
        $(slider)[0].slick.refresh();

        // clearInterval(timer);

        changeArrowPosition(slider);
        setCurrItemSize(slider);

        // const timer = setTimeout(() => {
        // 	changeArrowPosition(slider);
        // 	setCurrItemSize(slider);
        // }, 0);
    });
	});
};

const openForm = () => {
  const btns = document.querySelectorAll('.js-open-form');
  const isForm = document.querySelectorAll('.js-order-form').length != 0;

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if(isForm){
        const isMobile = window.matchMedia('(max-width: 980px)').matches;
        const form = document.querySelector('.js-order-form');
        const parentPopup = btn.closest('.js-basket');
        const parentPopupMobile = btn.closest('.js-basket-mobile');

        if(isMobile){
          parentPopupMobile.classList.remove('active');
        }else{
          parentPopup.classList.remove('active');
        }

        form.classList.add('active');
      }else{
        console.log('Ошибка: нету формы заказа на странице');
      }
    });
  });
};
const truncate = () => {
  const truncateNodes = document.querySelectorAll('.js-truncate-node');

  truncateNodes.forEach((item) => {
    const maxNumber = item.getAttribute('data-truncate-number') | 27;
    const text = item.textContent.slice(0, maxNumber);
    const isTruncate = item.textContent.length > maxNumber;

    if(isTruncate){
      item.textContent = `${text}...`;
    }
  });
};
(() => {
	const containers = [
		...document.querySelectorAll('.tariffs__type-col'),
		...document.querySelectorAll('.popup-channel__scroll'),
		...document.querySelectorAll('.text-block__dropdown'),
		...document.querySelectorAll('.user-block figure'),
		// ...document.querySelectorAll('.homelist__col--table'),
		...document.querySelectorAll('.homelist__col--cities'),
	];

	containers.forEach((container) => {
		const Scrollbar = window.Scrollbar;

		const scrollbar = Scrollbar.init(container, { alwaysShowTracks: true });

		scrollbar.addListener(() => {
			const children = container.querySelectorAll('.tariffs__type-item');
			if (children.length) {
				children[children.length - 1].classList.add('no-border');
			}
		});
	});
})();

const collapse = () => {
	const collapseItems = document.querySelectorAll('.js-collapse');

	if (collapseItems.length && window.innerWidth <= 980) {
		collapseItems.forEach((collapse) => {
			const button = collapse.querySelector('.js-collapse-btn');

			const handleClick = () => {
				collapse.classList.toggle('opened');
			};

			button.addEventListener('click', handleClick);
		});
	}
};

const arrowTop = () => {
	const arrows = document.querySelectorAll('.js-arrow-top');

	if (arrows.length) {
		window.addEventListener('scroll', () => {
			arrows.forEach((arrow) => {
				arrow.addEventListener('click', () => {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				});
				if (
					document.documentElement.scrollTop >=
					window.innerHeight / 5
				) {
					arrow.classList.add('active');
				} else {
					arrow.classList.remove('active');
				}
			});
		});
	}
};

const OD = {
	body: document.querySelector('body'),
	ESC_CODE: 27,
	mobile: 980,
	siteContent: document.querySelector('.site-content'),
	header: document.querySelector('.page-header'),
	footer: document.querySelector('.page-footer'),
	isIe11: !!window.MSInputMethodContext && !!document.documentMode,
	dropdown: document.querySelector('.js-global-dropdown'),
	globalDropdown: '',
};

if (OD.isIe11) {
	OD.body.classList.add('ie11');
}

const getCoords = (elem) => {
	let box = elem.getBoundingClientRect();

	return {
		top: box.top + pageYOffset,
		left: box.left + pageXOffset,
	};
};

const top_walker = (node, test_func, last_parent) => {
	while (node && node !== last_parent) {
		if (test_func(node)) {
			return node;
		}
		node = node.parentNode;
	}
};

// siblings
const getSiblings = (elem) => {
	var siblings = [];
	var sibling = elem.parentNode.firstChild;

	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== elem) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}

	return siblings;
};

const isWarning = document.querySelectorAll('.js-warning').length != 0;

if (isWarning) {
	OD.warningNode = document.querySelector('.js-warning');
	OD.warningCloseButton = OD.warningNode.querySelector('.js-close');
}

//form

const getFormPosition = (warningHeight) => {
	OD.warningHeight = isWarning ? OD.warningNode.offsetHeight : 0;

	const width = OD.body.clientWidth;
	const height = warningHeight || `${OD.warningHeight}px`;

	if (width > OD.mobile) {
		const forms = document.querySelectorAll('.js-order-form');
		const container = OD.footer.querySelector('.container');
		const right =
			width - (container.clientWidth + container.offsetLeft - 15);

		forms.forEach((form) => {
			form.style.top = height;
			form.style.right = `${right}px`;
			form.style.position = 'fixed';
		});
	}
};

document.addEventListener('DOMContentLoaded', () => getFormPosition());

window.addEventListener('resize', () => getFormPosition());

if (isWarning) {
	OD.warningCloseButton.addEventListener('click', () =>
		getFormPosition('0px')
	);
}

class Basket {
	constructor() {
		this.basket = document.querySelector('.js-basket');
		this.basketMobile = document.querySelector('.js-basket-mobile');
		this.openBtns = document.querySelectorAll('.js-basket-open');
		this.openBtnsMobile = document.querySelectorAll('.js-basket-open-mob');
		this.closeBtns = document.querySelectorAll('.js-close-basket');
	}

	open() {
		this.basket.classList.add('active');
	}

	close() {
		this.basket.classList.remove('active');
	}

	openMobile() {
		this.basketMobile.classList.add('active');
		OD.body.classList.add('overflow');
		OD.header.style.zIndex = 1001;
	}

	closeMobile() {
		this.basketMobile.classList.remove('active');
		OD.body.classList.remove('overflow');
		OD.header.style.zIndex = 999;
	}

	handleButtonClick() {
		this.basket.classList.toggle('active');
	}

	handleButtonClickMobile() {
		this.basketMobile.classList.contains('active')
			? this.closeMobile()
			: this.openMobile();
	}

	handleClose() {
		this.closeMobile();
		this.close();
	}

	handleOutClick(evt) {
		const btn = evt.target.classList.contains('js-basket-open');

		const isClickWithinOpenedDiv = top_walker(evt.target, (node) => {
			return node === this.basket || evt.target.closest('.js-toggle');
		});

		if (!isClickWithinOpenedDiv && !btn) {
			this.close();
		}
	}

	handleEscapePress(evt) {
		if (evt.key === 'Escape') {
			this.handleClose();
		}
	}

	init() {
		this.openBtns.forEach((btn) => {
			btn.addEventListener('click', this.handleButtonClick.bind(this));
		});

		this.openBtnsMobile.forEach((btn) => {
			btn.addEventListener(
				'click',
				this.handleButtonClickMobile.bind(this)
			);
		});

		this.closeBtns.forEach((btn) => {
			btn.addEventListener('click', this.handleClose.bind(this));
		});

		document.addEventListener(
			'click',
			this.handleOutClick.bind(this),
			true
		);

		document.addEventListener('keydown', this.handleEscapePress.bind(this));
	}
}

const basket = new Basket();
basket.init();


const hidePlaceholder = () => {
  document.querySelectorAll('.input-with-placeholder').forEach(item => {
    item.addEventListener('input', (e) => {
      if (e.currentTarget.value !== '') {
        document.querySelector('.input__placeholder').style.display = 'none'
      } else {
        document.querySelector('.input__placeholder').style.display = null;
      }
    })
  })
}

const gettableHeight = () => {
  document.querySelectorAll('.homelist__col--table').forEach(item => {
    item.style.maxHeight = document.querySelector('.homelist__col--cities').offsetHeight + 'px';
  })
}

// utility
masks();
parsley();
wow();
tabs();
select();
accordion();
toggle();
popupGallery();
productAnimate();
tariffSwitcher();
truncate();
collapse();

// specific
orderForm();
mobileMenu();
map();
tag();
cardChannel();
popupChannel();
mobileForm();
subTag();
switcher();
tariffThemeSwitch();
tariffDetailThemeSwitch();
warning();
openForm();
arrowTop();

// sliders
swiper();
historySlider();
tariffSlider();
newsSlider();
tariffDetailSlider();
hidePlaceholder();
gettableHeight()

